<template>
  <div class="dashboard-container">
    <div>
      <div class="content-wrapper">
        <aside class="sidebar">
          <div class="logo-container">
            <div class="logo">
              <img src="/img/logo.png" alt="APA Insurance" class="logo" />
            </div>
          </div>
          <div v-for="(item, index) in menuItems" :key="index">
            <div
              class="sidebar-item"
              :class="{
                active: activeIndex === index,
                'has-submenu': item.submenu && item.submenu.length > 0
              }"
              @click="toggleMenu(index, item)"
            >
              <img :src="item.icon" :alt="item.label + ' Icon'" class="menu-icon">
              <span>{{ item.label }}</span>
            </div>
            <div v-if="item.submenu && item.submenu.length > 0 && expandedMenus.includes(index)" class="submenu">
              <div
                v-for="(subItem, subIndex) in item.submenu"
                :key="subIndex"
                class="submenu-item"
                :class="{ active: activeSubmenuIndex === subIndex && activeIndex === index }"
                @click.stop="setActiveSubmenu(index, subIndex, subItem.url, subItem.component)"
              >
                <span class="submenu-bullet">•</span>
                <span>{{ subItem.label }}</span>
              </div>
            </div>
          </div>
        </aside>
        <component
          :is="currentComponent"
          :selectedUserType="selectedUserType"
          @captureUserDetails="handleCaptUserDetails"
          @change-component="setCurrentComponent"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  components: {
    LandingScreen: () => import('@/admin/components/LandingScreen.vue'),
    UserManagement: () => import('@/admin/components/UserManagement.vue'),
    RegisterUser: () => import('@/admin/components/RegisterUser.vue'),
    AddUsersModal: () => import('@/admin/components/modals/AddUsersModal.vue'),
    RoleManagement: () => import('@/admin/components/RoleManagement.vue'),
    RegisterRole: () => import('@/admin/components/RegisterRole.vue'),
    ModuleManagement: () => import('@/admin/components/ModuleManagement.vue'),
    ProductSetup: () => import('@/admin/components/ProductSetup.vue'),
    EditProduct: () => import('@/admin/components/EditProduct.vue'),
    Reports: () => import('@/admin/components/reports/Reports.vue'),
  },
  data() {
    return {
      currentComponent: 'LandingScreen',
      selectedUserType: null,
      activeIndex: 0,
      activeSubmenuIndex: -1,
      expandedMenus: [1],
      menuItems: [
        {
          label: 'Dashboard',
          icon: '/img/icons/dashboard.png',
          url: '/admin/AdminDashboard',
          component: 'LandingScreen',
        },
        {
          label: 'General Setup',
          icon: '/img/icons/user.png',
          url: '/general-setup',
          submenu: [
            {
              label: 'Onboard User',
              url: '/admin/UserManagement',
              component: 'UserManagement',
            },
            {
              label: 'Role Management',
              url: '/admin/RoleManagement',
              component: 'RoleManagement',
            },
            {
              label: 'Module Management',
              url: '/admin/ModuleManagement',
              component: 'ModuleManagement',
            }
          ]
        },
        {
          label: 'Product Setup',
          icon: '/img/icons/product.png',
          url: '/admin/ProductSetup',
          component: 'ProductSetup',
        },
        {
          label: 'Reports',
          icon: '/img/icons/doc.png',
          url: '/admin/Reports',
          component: 'Reports',
        },
      ],
    };
  },
  methods: {
    handleCaptUserDetails(captureUserDetails) {
      console.log('Event received! Data:', captureUserDetails);
      this.selectedUserType = captureUserDetails;
      this.currentComponent = 'RegisterUser';
      console.log('Current component set to:', this.currentComponent, 'with user type:', captureUserDetails);
    },
    setCurrentComponent(componentName) {
      this.currentComponent = componentName;
    },
    toggleMenu(index, item) {
      if (item.submenu && item.submenu.length > 0) {
        if (this.expandedMenus.includes(index)) {
          this.expandedMenus = this.expandedMenus.filter(function(i) { return i !== index; });
        } else {
          this.expandedMenus.push(index);
        }

        this.activeIndex = index;
      } else {
        this.setActive(index, item);
        // Clear any active submenu
        this.activeSubmenuIndex = -1;
      }
    },

    setActive(index, item) {
      this.activeIndex = index;
      window.history.pushState({}, '', item.url);
      this.expandedMenus = this.expandedMenus.filter(function(i) { return i === index; });
      if (item.component) {
        this.currentComponent = item.component;
      } else {
        this.currentComponent = 'LandingScreen';
      }
    },

    setActiveSubmenu(parentIndex, subIndex, url, component) {
      this.activeIndex = parentIndex;
      this.activeSubmenuIndex = subIndex;
      window.history.pushState({}, '', url);
      if (component) {
        this.currentComponent = component;
      } else {
        this.currentComponent = 'LandingScreen';
      }
    },
    mounted() {
      var currentPath = window.location.pathname;

      var self = this;
      this.menuItems.forEach(function(item, index) {
        if (item.url === currentPath) {
          self.activeIndex = index;
        }

        if (item.submenu) {
          item.submenu.forEach(function(subItem, subIndex) {
            if (subItem.url === currentPath) {
              self.activeIndex = index;
              self.activeSubmenuIndex = subIndex;
              if (!self.expandedMenus.includes(index)) {
                self.expandedMenus.push(index);
              }
            }
          });
        }
      });
    }
  },
}
</script>

<style scoped>
.dashboard-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  font-family: 'Roboto', sans-serif;
  background-color: #f0f2f5 !important;
}

.sidebar {
  width: 16%;
  background-color: #EDEDED;
  padding: 1rem 0;
  border-right: 1px solid #e0e0e0;
  position: relative;
  height: 100vh;
}


.sidebar-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1.5rem;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
  background-color: #f8f9fa;
  color: #164194 !important;
}

.sidebar-item:hover {
  background-color: #e9ecef;
}

.submenu {
  background-color: #f0f0f0;
  padding-left: 1rem;
}

.submenu-item {
  display: flex;
  align-items: center;
  padding: 0.6rem 1rem 0.6rem 2rem;
  font-size: 0.85rem;
  cursor: pointer;
  color: #164194;
  transition: background-color 0.2s;
}

.submenu-item:hover {
  background-color: #e5e5e5;
}

.submenu-bullet {
  margin-right: 0.5rem;
  font-size: 1.2rem;
  line-height: 0.5;
  color: #164194;
}

.sidebar-item.active {
  background-color: #777 !important;
  border-left: 5px solid #E41518 !important;
}

.submenu-item.active {
  background-color: #e0e0e0;
  font-weight: 500;
}

.menu-icon {
  width: 20px;
  height: auto;
  vertical-align: middle;
}

.sidebar-item span {
  color: #164194;
}

.sidebar-item .menu-icon {
  filter: brightness(0) saturate(100%) invert(17%) sepia(92%) saturate(2350%) hue-rotate(212deg) brightness(95%) contrast(97%);
}

.sidebar-item.active span {
  color: #FFFFFF !important;
}

.sidebar-item.active .menu-icon {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7462%) hue-rotate(236deg) brightness(113%) contrast(101%);
}

.logo {
  height: 100px;
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  padding-bottom: 40px;
}

.content-wrapper {
  display: flex;
  flex: 1;
  overflow: hidden;
}
</style>
